import React from 'react';
import StatusChip, { toneForStatus } from '../../Components/StatusChip';

const chipFields = new Set([
    'activity_level', 'certification_status', 'Project Status', 'project_status',
    'order_type', 'course_type', 'is_email_sent',
]);
const unavailable = new Set(['', '-', 'na', 'n/a', 'null', 'undefined']);
const reportTone = value => {
    const text = String(value).trim().toLowerCase().replace(/[ _-]+/g, ' ');
    if (['certified', 'passed', 'yes'].includes(text)) return 'green';
    if (['inactive', 'not certified', 'not started', 'no'].includes(text)) return 'grey';
    if (['in progress', 'learning hub', 'licence', 'license'].includes(text)) return 'blue';
    return toneForStatus(value);
};

// Decorate display columns only; raw rows, sorting, filters, and downloads stay unchanged.
export const withReportChips = columns => columns.map(column => {
    const score = /^g[1-6]_average$/.test(column.key);
    if (!score && !chipFields.has(column.key)) return column;
    return {
        ...column,
        render: row => {
            const value = column.render ? column.render(row) : row[column.key];
            if (!['string', 'number'].includes(typeof value) || unavailable.has(String(value).trim().toLowerCase())) {
                return value == null ? '' : value;
            }
            return <StatusChip tone={score ? 'blue' : reportTone(value)}>{value}</StatusChip>;
        },
    };
});
